// import React, { useState, useEffect } from "react";
// import "./createRole.scss";
// import Button from "components/Button/index";
// import RoleOperation from "./RoleOperations/index";

// const CreateRole = ({
//   handlestep,
//   updateRoleName,
//   updateOperations,
//   initialRoleName,
//   initialOperations
// }) => {
//   const [roleName, setRoleName] = useState(initialRoleName || "");

//   useEffect(() => {
//     setRoleName(initialRoleName || "");
//   }, [initialRoleName]);

//   const handleInputChange = (e) => {
//     setRoleName(e.target.value);
//     updateRoleName(e.target.value);
//   };

//   return (
//     <div className="CreateRole">
//       <div className="CreateRoleWrapper">
//         <div className="CreateRoleWrapperContent">
//           <p>Role</p>
//           <input
//             type="text"
//             placeholder="Role name"
//             value={roleName}
//             onChange={handleInputChange}
//             className="CreateRoleWrapperContentInput"
//           />
//         </div>
//         <RoleOperation
//           updateOperations={updateOperations}
//           initialOperations={initialOperations}
//         />
//       </div>
//       <Button
//         type="violet"
//         title="Assign Access"
//         onClick={handlestep}
//         disabled={!roleName.trim() || initialOperations.length === 0}
//       />
//     </div>
//   );
// };

// export default CreateRole;


import React, { useState, useEffect, useRef } from "react";
import "./createRole.scss";
import Button from "components/Button/index";
import RoleOperation from "./RoleOperations/index";

const CreateRole = ({
  handlestep,
  updateRoles,
  updateOperations,
  initialRoles,
  initialOperations
}) => {
  const [roles, setRoles] = useState(initialRoles || "");
  const inputRef= useRef(null);

  useEffect(() => {
    setRoles(initialRoles || "");
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [initialRoles]);

  const handleInputChange = (e) => {
    setRoles(e.target.value);
    updateRoles(e.target.value);
  };

   const handleKeyDown = (e) => {
    
    if (
      e.key === "Enter" &&
      roles.trim() &&
      initialOperations.length > 0
    ) {
      e.preventDefault(); // Prevent form submission or page reload
      handlestep();
    }
  };

  return (
    <div className="CreateRole">
      <div className="CreateRoleWrapper">
        <div className="CreateRoleWrapperContent">
          <p>Role</p>
          <input
            ref={inputRef}
            type="text"
            placeholder="Role name"
            value={roles}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            className="CreateRoleWrapperContentInput"
          />
        </div>
        <RoleOperation
          updateOperations={updateOperations}
          initialOperations={initialOperations}
          handleKeyDown={handleKeyDown}
        />
      </div>
      <Button
        type="violet"
        title="Create Role"
        onClick={handlestep}
        disabled={!roles.trim() || initialOperations.length === 0}
      />
    </div>
  );
};

export default CreateRole;